// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pdf-printable-container {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  overflow: visible;
  width: 210mm;
  gap: 5mm;
}

.pdf-section-title {
  margin-bottom: 5mm;
}

.pdf-flex-column-container {
  display: flex;
  flex-direction: column;
  gap: 5mm;
}

.pdf-flex-row-container {
  display: flex;
  flex-direction: row;
  gap: 5mm;
}

@media print {
  .pdf-printable-container {
    page-break-before: avoid;
    page-break-after: avoid;
    page-break-inside: avoid;
  }

  .pdf-section-title {
    page-break-after: avoid;
    page-break-before: avoid;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Applications/GuardianReport/PdfReport/custom.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE;IACE,wBAAwB;IACxB,uBAAuB;IACvB,wBAAwB;EAC1B;;EAEA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;AACF","sourcesContent":[".pdf-printable-container {\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n  overflow: visible;\n  width: 210mm;\n  gap: 5mm;\n}\n\n.pdf-section-title {\n  margin-bottom: 5mm;\n}\n\n.pdf-flex-column-container {\n  display: flex;\n  flex-direction: column;\n  gap: 5mm;\n}\n\n.pdf-flex-row-container {\n  display: flex;\n  flex-direction: row;\n  gap: 5mm;\n}\n\n@media print {\n  .pdf-printable-container {\n    page-break-before: avoid;\n    page-break-after: avoid;\n    page-break-inside: avoid;\n  }\n\n  .pdf-section-title {\n    page-break-after: avoid;\n    page-break-before: avoid;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
